export default __webpack_public_path__ + "2744ce99a92921d242530b4e20f54a0d.png";